import {
    FilterDrawerExtraData,
    FilterDrawerGroupExtraData,
} from "@components/FilterDrawer/interface";
import { FilterState } from "@redux/plugins/filter-manager/interface";
import type { PaginationState } from "@redux/plugins/pagination-manager/interface";
import type { DEFAULT_STATUS } from "@redux/utils/helpers";

export interface TaxBatchItem {
    id: number;
    skuId: number;
    quantityReceived: number;
    quantityUsed: number;
    nfeKey: string | null;
    price: number | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

export interface PaginationParams {
    skuId?: string;
    limit?: number;
    page?: number;
    createdAtMin?: string;
    createdAtMax?: string;
}

export type State = {
    message: string | null;
    status: DEFAULT_STATUS;
    filters: FilterState<FilterDrawerExtraData, FilterDrawerGroupExtraData>;
    taxBatchs: PaginationState<TaxBatchItem, Record<string, never>>;
};

export const moduleId = "taxBatchs" as const;
